define('constants/liveReceptionistScriptTypeConstants',[], function () {
    return  {
        Unknown: 0,
        LiveReceptionist: 1,
        WebChat: 2,
        OutboundCalling: 3,
    };
});

